import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsRouteModule } from './reports-route.module';
import { ReportsComponent } from './reports.component'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule} from '@angular/forms';
import {RadioButtonModule} from 'primeng/radiobutton';
import { TranslateModule } from '@ngx-translate/core';
import {CalendarModule} from 'primeng/calendar';
import {ToastModule} from 'primeng/toast';
import { MultiSelectModule } from 'primeng/multiselect';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    ReportsRouteModule,
    NgbModule,
    FormsModule,
    RadioButtonModule,
    SharedModule,
    CalendarModule,
    TranslateModule,
    ToastModule,
    MultiSelectModule
  ],
  declarations: [ReportsComponent]
})
export class ReportsModule { }
